import { Injectable } from "@angular/core";
import { SocketService } from "../socket.service";
import { DestructorService } from "@core-services/destructor.service";
import { TranslationService } from "@core-services/translation.service";
import { InitService } from "@core-services/init.service";
import { debug } from "@helpers/debug";
import { DerivativeService } from "./derivative.service";
import { Etc } from "@models/derivative/currencies/etc";

@Injectable({
	providedIn: "root"
})
export class EtcService extends DerivativeService<Etc> {
	public constructor(
		protected initService: InitService,
		protected socketService: SocketService,
		protected translationService: TranslationService,
		protected destructor: DestructorService
	) {
		super(initService, destructor, translationService, socketService, "EtcService");
	}

	public logoUrl(item: Etc, grayVersion: boolean = false): string {
		let url = "assets/images/logos/";

		if (grayVersion) {
			url += "etcs/" + item.getSymbol(true) + "-grey-half-transparent";
		} else {
			url += "etcs/etcs-" + item.getSymbol(true);
		}

		return url;
	}

	public startSockets(): void {
		if (debug) {
			console.log("[DEBUG]: listen to etc updates");
		}

		const priceRoom = {
			room: "etc_prices",
			collection: "etcs",
			type: Etc,
			isPrivate: false
		};
		const tradableRoom = {
			room: "etcs",
			collection: "etcs",
			type: Etc,
			isPrivate: false
		};
		this.initSockets(priceRoom, tradableRoom);
	}
}
